export default {
  // 模块名称
  changeJob: {
    // 按钮类
    button: {
      query: '查询',
      reset: '重置',
      export: '导出',
      close: '关闭',
      detail: '查看'
    },
    // 文字标签类
    label: {
      jobNumber: '工号',
      image: '照片',
      name: '姓名',
      isDuty: '上岗/下岗',
      post: '岗位',
      postType: '岗位类型',
      time: '时间',
      operations: '操作',
      to: '至'
    },
    // 提示类
    placeholder: {
      select: '请选择',
      startDate: '开始日期',
      endDate: '结束日期'
    },
    // 消息类
    message: {},
    // 标题类
    title: {
      detail: '记录详情'
    }
  }
}